import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./style.css";
import { Link } from "react-router-dom";
const SecondAbout = () => {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);
    setTimeout(() => {
        var bodyWidth = document.querySelector("body").clientWidth;
        if (bodyWidth < 800) {
            document
                .querySelectorAll(".pic")
                .forEach((el) => (el.style.width = `${bodyWidth - 22}px`));
        }
    }, 1000);
    const [lang, setLang] = useState("En");
    useEffect(() => {
        if (localStorage.getItem("language") === "En") {
            setLang("En");
        } else if (localStorage.getItem("language") === "Fr") {
            setLang("Fr");
        }
    }, []);
    return (
        <div class="corpix-about-section section bg-about">
            <div class="container">
                <h1
                    style={{
                        fontSize: "48px",
                        color: "#fff",
                        textAlign: "center",
                        transform: "translateY(-40px)",
                    }}
                >
                    <span style={{ color: "#daa520" }}>
                        {lang === "Fr" ? `QUI` : `About`}
                    </span>{" "}
                    {lang === "Fr" ? `SOMMES-NOUS` : `Us`}
                </h1>
                <div class="abt-sec-wrp style2">
                    <div class="row">
                        <div
                            class="col-md-6 col-sm-12 col-lg-6"
                            data-aos="fade-right"
                            data-aos-delay="200"
                        >
                            <div class="abt-vdo style2 brd-rd5 about-images">
                                <div className="pic" id="pic3" />
                                <div className="pic" id="pic2" />
                                <div className="pic" id="pic1" />
                            </div>
                        </div>
                        <div
                            class="col-md-6 col-sm-12 col-lg-6"
                            data-aos="fade-left"
                            data-aos-delay="200"
                        >
                            <div class="abt-desc">
                                <div class="sec-tl">
                                    {/* <span class="theme-clr">Our History</span> */}
                                </div>
                                <p class="description">
                                    {lang === "Fr"
                                        ? `Nous avons une gamme exceptionnelle de lingots
d’or disponibles à l’achat ici à Gold Bar
International Ltd Company. Dans notre collection,
vous trouverez des lingots d’or des principaux
raffineurs d’or, notamment PAMP Suisse, Umicore
et Metalor.`
                                        : `We have an outstanding range of golden bars
                                    available to purchase here at Gold Bar
                                    International Ltd Company. In our
                                    collection, you will find gold bars from
                                    leading gold refiners, including PAMP
                                    Suisse, Umicore and Metalor.`}
                                </p>

                                <div class="about-btns">
                                    <Link
                                        to="/about-us"
                                        class="theme-btn theme-bg brd-rd5"
                                    >
                                        {lang === "Fr"
                                            ? `LIRE LA SUITE`
                                            : `READ MORE`}
                                    </Link>
                                    <Link
                                        to="/contact-us"
                                        class="theme-btn contact-btn  brd-rd5"
                                    >
                                        {lang === "Fr"
                                            ? `CONTACTEZ-NOUS`
                                            : `CONTACT US`}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SecondAbout;
